<template>
  <div class="wholePage">
    <v-container fluid class="pa-0">

      <Toolbar title="Product Ideas" ></Toolbar>
      <v-content app >
        <IdeaFilter></IdeaFilter>
        <v-layout row wrap fluid class="landing pa-2">
            <PinterestCard v-for="idea in ideas" :item="idea" ></PinterestCard>
        </v-layout>
      </v-content>

    </v-container>
    <BigFooter></BigFooter>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import firebase from 'firebase/app'


import Toolbar from '../Toolbar.vue'
import BigFooter from '../BigFooter'
import PinterestCard from './PinterestCard.vue'
import IdeaFilter from './IdeaFilter.vue'

export default {
  components: {
    Toolbar,BigFooter, PinterestCard, IdeaFilter
  },
  data () {
    return {
      showWhy: false,
      ideas: [],
    }
  },
  mounted () {
    if (typeof window.parsePinBtns != "undefined") {
      window.parsePinBtns()
    } else {
      // Dynamically load stripeScript
      const pinterestScript = document.createElement('script')
      pinterestScript.setAttribute('src', 'https://assets.pinterest.com/js/pinit.js')
      pinterestScript.setAttribute('data-pin-build', 'parsePinBtns')
      document.head.appendChild(pinterestScript)
      console.log("LOADED PINTEREST")
    }

    // Load the items
    this.loadIdeas().then( () => {
      window.setTimeout(() => {
        console.log("PARSING...")
        window.parsePinBtns()

      }, 200)
    })



  },
  computed: {
    ...mapState({
      dialogOpen: state => state.mgmt.dialogOpen
    }),
  },
  methods: {
    loadIdeas: async function () {
      // Load all the items
      let ref = await firebase.firestore().collection('ideas')
      let querySnap = await ref.get()
      querySnap.forEach( (doc) => {
        this.ideas.push(doc.data())
      })

    }
  }
}
</script>

<style scoped>
/* "scoped" attribute limit the CSS to this component only */

.linktext {
  color: white;
}
.wholePage {
  background-color: #FFFFFF;
}
.landing {
  background-image:
    linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url("/images/blur-close-up-crafts-6435.jpg");
  background-image:
    linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url("/images/blur-close-up-crafts-6435.webp");
  background-color: #cccccc;
  background-size: cover;
  /* height: 80vh; */
  color: #FFFFFF;
  font-weight: bold;
}

</style>
